// extracted by css-extract-rspack-plugin
export default {"labelText":"labelText-1dLqh","inputWrapper":"inputWrapper-1M6rf","input":"input-QwEWu","invalid":"invalid-M4T1C","textarea":"textarea-1gbXv","inputSuffix":"inputSuffix-331Dv"};